import clsx from 'clsx'
import React, { FC, ReactNode } from 'react'

interface IHeadPage {
  title?: string
  className?: string
  // shown right after the title (a status such as "draft saved")
  children?: ReactNode
}

// The page title is the page's h1, in the redesign's 28px black
const HeadPage: FC<IHeadPage> = ({ title, className, children }) => {
  return (
    <section
      className={clsx(
        'flex flex-row flex-wrap items-center gap-x-5 gap-y-1 md:w-1/2 min-h-10 md:min-h-11',
        className,
      )}
    >
      {title && (
        <h1 className="text-[1.375rem] md:text-[1.75rem] font-black leading-tight text-ink">
          {title}
        </h1>
      )}
      {children}
    </section>
  )
}

export default HeadPage
